import { useCallback, useState, useEffect } from 'react';
export default function useGeolocation({ onSuccess, onError } = {}) {
    const [provider, setProvider] = useState(undefined);
    const [position, setPosition] = useState();
    useEffect(() => {
        setProvider(typeof navigator !== 'undefined' && navigator.geolocation);
    }, []);
    const success = useCallback(position => {
        setPosition(position);
        onSuccess && onSuccess(position);
    }, [onSuccess, setPosition]);
    const error = useCallback(err => {
        setPosition(undefined);
        onError && onError(err);
    }, [onError, setPosition]);
    const getPosition = useCallback(config => {
        if (!provider)
            return;
        provider.getCurrentPosition(success, error, config);
    }, [provider, error, success]);
    const watchPosition = useCallback(config => {
        if (!provider)
            return;
        const id = provider.watchPosition(success, error, config);
        return () => provider.clearWatch(id);
    }, [provider, error, success]);
    return {
        isAvailable: !!provider,
        position,
        getPosition,
        watchPosition
    };
}
//# sourceMappingURL=useGeolocation.js.map